import type { ReactNode } from 'react'
import {
  LearningContentText,
  renderLearningContentInline,
} from '@quebon/shared-learning/components/common/LearningContentText'

interface Props {
  text: string
  className?: string
}

const SHORT_POINT_PREFIX_PATTERN = /^[ \t]*포인트[ \t]*[:：][ \t]*/

export function stripShortPointPrefix(text: string): string {
  return text.replace(SHORT_POINT_PREFIX_PATTERN, '')
}

export function renderWarmupInline(line: string): ReactNode[] {
  return renderLearningContentInline(line)
}

export function WarmupTextView({ text, className }: Props) {
  return (
    <p className={className}>
      <LearningContentText text={text} />
    </p>
  )
}
